"use client";

import React from "react";
import { INITIAL_DRAWER_CONTEXT } from "./consts";
import type { DrawerContextType } from "./types";

export const DrawerContext = React.createContext<DrawerContextType>(
  INITIAL_DRAWER_CONTEXT,
);
